// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"710":"d9f2e9c8","943":"20a89b00"}[chunkId] + ".chunk.js";
};